import { ShieldCheck, Leaf, Hammer, Sparkles } from "lucide-react";

const PILLARS = [
  {
    icon: ShieldCheck,
    title: "Safe by Design",
    body:
      "We build for the people who live inside. Non-toxic finishes, healthy air, and assemblies that resist mold, rot, fire, and pests.",
  },
  {
    icon: Hammer,
    title: "Superior Craft",
    body:
      "Trim lines that meet. Mitres that hold. Decades-long building science applied to every framed wall and finished surface.",
  },
  {
    icon: Leaf,
    title: "Sustainable Materials",
    body:
      "From locally sourced lumber to our patented Z Panel hempcrete, we choose materials that age well and tread lightly.",
  },
  {
    icon: Sparkles,
    title: "Transparent Process",
    body:
      "Fixed schedules, clean job sites, and clear weekly updates. You'll always know what's happening on your build.",
  },
];

export const WhyUs = () => {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative bg-[#1A1D1A] text-[#F4F3EF] py-24 sm:py-32 overflow-hidden"
    >
      {/* texture */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(rgba(244,243,239,0.4) 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-10">
        <div className="reveal max-w-3xl">
          <div className="text-xs tracking-[0.25em] uppercase font-bold text-[#C9B07A]">
            02 — Why Sativa
          </div>
          <h2 className="font-display font-bold mt-5 text-4xl sm:text-5xl lg:text-[56px] leading-[1.04] tracking-tight">
            High quality, safe,
            <br />
            <span className="italic font-light text-[#C9B07A]">and superior.</span>
          </h2>
          <p className="font-body text-[#F4F3EF]/75 mt-6 text-base sm:text-lg leading-relaxed">
            Sativa Building Systems has spent years engineering safer wall
            assemblies — the patented Z Panel is proof. We&apos;re bringing that
            same standard of materials science and craft to every general
            contracting job we take.
          </p>
        </div>

        <div className="reveal mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {PILLARS.map((p) => (
            <div
              key={p.title}
              data-testid={`pillar-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-[#1A1D1A] p-8 sm:p-10 hover:bg-[#222621] transition-colors duration-500"
            >
              <p.icon size={26} className="text-[#C9B07A]" strokeWidth={1.5} />
              <h3 className="font-display font-bold mt-6 text-xl sm:text-2xl tracking-tight">
                {p.title}
              </h3>
              <p className="font-body mt-4 text-[14.5px] leading-relaxed text-[#F4F3EF]/70">
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
